/* BG: <bg-back-to-top> — port of Ella's back-to-top-button (halo-recently-viewed.js) without jQuery.
   Visible once scrollY / document height > 0.07 (passive, rAF-throttled scroll listener); click scrolls to the top
   (smooth, or instant when prefers-reduced-motion is set). Hidden state is aria-hidden and out of the tab order. */
if (!customElements.get('bg-back-to-top')) {
  customElements.define(
    'bg-back-to-top',
    class BgBackToTop extends HTMLElement {
      constructor() {
        super();
        this.threshold = 0.07;
        this.ticking = false;
        this.onScroll = this.onScroll.bind(this);
        this.onClick = this.onClick.bind(this);
        this.onKeydown = this.onKeydown.bind(this);
      }

      connectedCallback() {
        window.addEventListener('scroll', this.onScroll, { passive: true });
        this.addEventListener('click', this.onClick);
        this.addEventListener('keydown', this.onKeydown);
        this.update();
      }

      disconnectedCallback() {
        window.removeEventListener('scroll', this.onScroll);
        this.removeEventListener('click', this.onClick);
        this.removeEventListener('keydown', this.onKeydown);
      }

      onScroll() {
        if (this.ticking) return;
        this.ticking = true;
        window.requestAnimationFrame(() => {
          this.ticking = false;
          this.update();
        });
      }

      update() {
        const documentHeight = document.documentElement.scrollHeight || 1;
        const visible = window.scrollY / documentHeight > this.threshold;
        if (this.dataset.visible === String(visible)) return;
        this.dataset.visible = String(visible);
        this.setAttribute('aria-hidden', visible ? 'false' : 'true');
        this.tabIndex = visible ? 0 : -1;
      }

      onClick() {
        const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        window.scrollTo({ top: 0, behavior: reduceMotion ? 'auto' : 'smooth' });
      }

      onKeydown(event) {
        if (event.key === 'Enter' || event.key === ' ' || event.key === 'Spacebar') {
          event.preventDefault();
          this.onClick();
        }
      }
    }
  );
}
